var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 30,
    viewBox: "0 0 64 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 16,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#A1C7FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 20,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#A1C7FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 20,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#A1C7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChair);
export default __webpack_public_path__ + "static/media/barChair.19658c8869aa4e2a00717b92926658b7.svg";
export { ForwardRef as ReactComponent };